import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PageHeader from "../../components/layout/LayoutWrapper/PageHeader";
import userImg from "../../assets/userImg.png";
import Text from "../../components/typography/Text";
import Grid from "../../components/layout/grid/Grid";
import CustomButton from "../../components/common/CustomButton/CustomButton";
import CustomTextInputBasic from "../../components/common/CustomTextInput/CustomTextInputBasic";
import CustomSelectBasic from "../../components/common/CustomSelect/CustomSelectBasic";
import ResubmissionModal from "./ResubmissionModal";
import { Setting06Icon } from "hugeicons-react";
import { Settings } from "lucide-react";
import { Info } from "lucide-react";
import ServerPaginationDataGridWithReactQuery from "../../components/common/CustomDataGrid/ServerPaginationDataGridWithReactQuery";
import LeadNameHover from "./LeadNameHover";
import ProductHover from "./ProductHover";
import LastpaymentHover from "./LastpaymentHover";
import AccessModal from "./AccessModal";
import { getadvisorDetailsFn, getadvisorLeadDetailsFn, getAdvisorStaticDataById, getAdvisorStaticDataFn, getAllcategoriesFn, getAllcompanyFn, getCategoryaccessFn, getComponyaccessFn } from "../../Services/advisorService";
import AdvisorProfile from "./AdvisorProfile";
import { advisorleadDataUrl } from "../../utils/urls";

const AdvisorInfoPage = () => {
  const [hoveredLeadId, setHoveredLeadId] = useState(null);
  const [hoveredProductId, setHoveredProductId] = useState(null);
  const [hoveredPaymentId, setHoveredPaymentId] = useState(null);
  const [accessModalToggle, setAccessModalToggle] = useState(false);
  const [advisorProfileToggle, setAdvisorProfileToggle] = useState(false);
  const [advisorleadData, setAdvisorleadData] = useState([]);
  const [companyAccessData, setCompanyAccessData] = useState([]);
  const [catagoryAccessData, setCatagoryAccessData] = useState([]);
  const [advisorProfileData, setAdvisorProfileData] = useState([]);
  const [staticcardData, setStaticcardData] = useState([]);
  const [status, setStatus] = useState(1);
  const [dep, setDep] = useState(false);

  const handleMouseEnter = (id, type) => {
    if (type === "lead") setHoveredLeadId(id);
    if (type === "product") setHoveredProductId(id);
    if (type === "payment") setHoveredPaymentId(id);
  };

  const handleMouseLeave = (type) => {
    if (type === "lead") setHoveredLeadId(null);
    if (type === "product") setHoveredProductId(null);
    if (type === "payment") setHoveredPaymentId(null);
  };
  const location = useLocation();

  const advisorData = location?.state?.advisor || {};
  console.log('add', advisorData);

  const advisorprofileDataFn = async () => {
    const data = await getadvisorDetailsFn(advisorData?.advisor_id);
    console.log('profiledata', data?.data);
    setAdvisorProfileData(data?.data);
  };

  const staticDataFn = async () => {
    const data = await getAdvisorStaticDataById(advisorData?.advisor_id);
    setStaticcardData(data?.data?.data?.[0]);
  };

  const getCatagoryTabData = async () => {
    console.log('cat', advisorData?.advisor_id);
    const allCatagories = await getAllcategoriesFn();
    const data = await getCategoryaccessFn(advisorData?.advisor_id);
    console.log('advisorcatagory', data);
    console.log('allcatagory', allCatagories);
    const activeCategories = allCatagories?.data?.data?.filter(
      item => item.is_active
    ) || [];

    setCatagoryAccessData([
      ...activeCategories,
      ...data?.data?.data?.data || [],
    ]);
  };

  const getCompanyTabDatafn = async () => {
    try {
      // 1. Get all companies
      const allCompaniesRes = await getAllcompanyFn();
      const allCompanies = allCompaniesRes?.data?.data || [];
      console.log("allCompanies", allCompanies);

      // 2. Get advisor access list
      const accessRes = await getComponyaccessFn(advisorData?.advisor_id);
      const accessList = accessRes?.data?.data?.data || [];

      const companyMap = new Map();

      // 3. Add all companies from API 1 into the map
      allCompanies.forEach((company) => {
        companyMap.set(company.company_id, {
          ...company,
          is_access: false, // default
          advisor_id: null,
        });
      });

      // 4. Merge in companies from API 2 (access list)
      accessList.forEach((item) => {
        const companyId = item.company_id?.company_id;
        const companyName = item.company_id?.company_name;

        if (companyMap.has(companyId)) {
          // Merge with existing
          const existing = companyMap.get(companyId);
          companyMap.set(companyId, {
            ...existing,
            is_access: item.is_access,
            advisor_id: item.advisor_id,
          });
        } else {
          // Company was not in first API — add it fresh
          companyMap.set(companyId, {
            company_id: companyId,
            company_name: companyName,
            logo_url: null,
            total_products: 0,
            converted_leads: 0,
            active_leads: 0,
            is_access: item.is_access,
            advisor_id: item.advisor_id,
          });
        }
      });

      // 5. Convert map to array and set it
      const mergedData = Array.from(companyMap.values());
      console.log('mergedData', mergedData);
      setCompanyAccessData(mergedData);
    } catch (error) {
      console.error('Error fetching company tab data:', error);
    }
  };

  const cardData = {
    leadsBrought: 25,
    convertedLeads: 10,
    totalEarning: "₹1,20,000",
    receivedEarning: "₹80,000",
    pendingPayout: "₹40,000",
  };

  const dataMapper = () => {
    const mappedData = advisorleadData?.map((lead) => ({
      id: lead?.lead_product_id,
      leadName: lead?.lead_id,
      Product: lead?.product_id,
      policyAmount: lead?.policy_amount,
      totalCommission: lead?.total_commission_amount,
      commissionReceived: lead?.total_commission_received,
      lastPaymentDate: {
        date: lead?.last_payment_date,
        logs: lead?.payment_logs || [],
      }
    }));

    console.log("MPPPP", mappedData);

    return { list: mappedData, total: mappedData.length };
  };

  const columns = [
    {
      field: "leadName",
      headerName: "Lead Name",
      renderCell: (row) => (
        console.log('lead', row),
        <div className="relative flex items-center gap-1">
          {row.lead_id.name}
          <div
            className="relative"
            onMouseEnter={() => handleMouseEnter(row.lead_id?.lead_display_id, "lead")}
            onMouseLeave={() => handleMouseLeave("lead")}
          >
            <Info className="w-4 h-4 text-gray-500 cursor-pointer" />
            {hoveredLeadId === row.lead_id?.lead_display_id && (
              <div className="absolute left-0 top-full z-50 bg-white p-2 min-w-[150px]">
                <LeadNameHover lead={row?.lead_id} status={row?.lead_status_id?.title} />
              </div>
            )}
          </div>
        </div>
      ),
    },
    { field: "lead_id", headerName: "Lead ID", renderCell: (row) => row.lead_id?.lead_display_id },
    { field: "lead_product_relation_display_id", headerName: "LPR ID"},
    {
      field: "Product",
      headerName: "Product",
      renderCell: (row) => {
        console.log('row', row);
        
        if (row?.product_id) {
          return (
            <div className="relative flex items-center gap-1">
              {row.product_id?.product_name}
              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter(row?.lead_product_id, "product")}
                onMouseLeave={() => handleMouseLeave("product")}
              >
                <Info className="w-4 h-4 text-gray-500 cursor-pointer" />
                {hoveredProductId === row?.lead_product_id && (
                  <div className="absolute left-0 top-full z-50 bg-white p-2 min-w-[150px]">
                    <ProductHover product={row?.product_id} />
                  </div>
                )}
              </div>
            </div>
          )
        } if (row?.sub_category_id) {
          return (
            <div className="relative flex items-center gap-1">
              {row?.sub_category_id?.title}
              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter(row?.lead_product_id, "product")}
                onMouseLeave={() => handleMouseLeave("product")}
              >
                <Info className="w-4 h-4 text-gray-500 cursor-pointer" />
                {hoveredProductId === row?.lead_product_id && (
                  <div className="absolute left-0 top-full z-50 bg-white p-2 min-w-[150px]">
                    <ProductHover product={row?.sub_category_id} />
                  </div>
                )}
              </div>
            </div>
          )
        } else if(row?.category_id) {
          return (
            <div className="relative flex items-center gap-1">
              {row?.category_id?.title}
              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter(row?.lead_product_id, "product")}
                onMouseLeave={() => handleMouseLeave("product")}
              >
                <Info className="w-4 h-4 text-gray-500 cursor-pointer" />
                {hoveredProductId === row?.lead_product_id && (
                  <div className="absolute left-0 top-full z-50 bg-white p-2 min-w-[150px]">
                    <ProductHover product={row?.category_id} />
                  </div>
                )}
              </div>
            </div>
          )
          
        } else {
          return "N/A";
        }
    },
    },
    {
      field: "policyAmount",
      headerName: "Policy Amount",
      renderCell: (row) => (
        <div>{row.policy_amount || "N/A"}</div>
      )
    },
    {
      field: "total_commission_amount",
      headerName: "Total Commission",
      renderCell: (row) => (
        <div>{row.total_commission_amount || "N/A"}</div>
      )
    },
    {
      field: "total_commission_received",
      headerName: "Commission Received",
      renderCell: (row) => (
        console.log("commission", row),
        <div>{row.total_commission_received >= 0 ? row.total_commission_received : "N/A"}</div>
      )
    },
    {
      field: "lastPaymentDate",
      headerName: "Last Payment Date",
      renderCell: (row) => {
        const formattedDate = new Date(row.last_payment_date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });

        return (
          <div className="relative flex items-center gap-1">
            {formattedDate}
            <div
              className="relative"
              onMouseEnter={() => handleMouseEnter(row?.lead_product_id, "payment")}
              onMouseLeave={() => handleMouseLeave("payment")}
            >
              <Info className="w-4 h-4 text-gray-500 cursor-pointer" />
              {hoveredPaymentId === row?.lead_product_id && (
                <div className="absolute right-0 top-full z-50 bg-white p-2 min-w-[150px]">
                  <LastpaymentHover logs={row?.payment_logs} />
                </div>
              )}
            </div>
          </div>
        );
      },
    }
  ];

  useEffect(() => {
    staticDataFn();
    getCatagoryTabData();
    advisorprofileDataFn();
    getCompanyTabDatafn();
  }, [dep]);

  useEffect(() => {
    advisorprofileDataFn();
  }, [status]);

  const getDefaultDates = () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    const toInputDate = (date) =>
      date.toLocaleDateString("en-CA"); // Format: YYYY-MM-DD

    return {
      startDate: toInputDate(firstDay),
      endDate: toInputDate(lastDay),
    };
  };

  const [dates, setDates] = useState(getDefaultDates());

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDates((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between border-b pb-4">
        <PageHeader title="Advisor Detail" showBack={true} />
        <div className="flex items-end gap-4">
          <div className="flex flex-col">
            <label htmlFor="startDate" className="text-sm text-gray-700 mb-1">
              Start Date
            </label>
            <input
              type="date"
              id="startDate"
              name="startDate"
              value={dates.startDate}
              onChange={handleChange}
              className="px-3 py-2 border rounded-md text-sm bg-white"
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="endDate" className="text-sm text-gray-700 mb-1">
              End Date
            </label>
            <input
              type="date"
              id="endDate"
              name="endDate"
              value={dates.endDate}
              onChange={handleChange}
              className="px-3 py-2 border rounded-md text-sm bg-white"
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col p-4 mb-2 bg-white border border-gray-200 rounded-md mt-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <img
              src={userImg}
              alt="Advisor"
              className="w-12 h-12 rounded-full object-scale-down bg-[#8080801c]"
            />
            <div>
              <Text className="!font-bold ml-2">{advisorData?.name}</Text>
              <Text className="!font-bold ml-2">{advisorData?.advisor_display_id}</Text>
            </div>
          </div>
          <div className="flex justify-between m-2">
            <CustomButton
              label="View Profile"
              variant="default"
              onClick={() => { setAdvisorProfileToggle(true) }}
            />
            <div className="ml-2">
              <CustomButton
                label="Access"
                startIcon={<Settings />}
                variant="outlined"
                onClick={() => {
                  setAccessModalToggle(true);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-6 mt-6 w-full">
        {[
          { label: "Leads Brought", value: staticcardData?.leads_brought },
          { label: "Converted Lead", value: staticcardData?.converted_lead },
          { label: "Total Earning", value: staticcardData?.total_earning },
          { label: "Received Earning", value: staticcardData?.received_earning },
          { label: "Pending Payout", value: staticcardData?.pending_payout },
        ].map((item, index) => (
          <div
            key={index}
            className="bg-white p-4 rounded-xl shadow-md flex flex-col min-w-0"
          >
            <div className="flex items-center">
              <div>
                <h3 className="text-lg font-semibold text-[#213650]">
                  {item.label}
                </h3>
                <p className="text-xl font-bold text-[#02336E]">{item.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <ServerPaginationDataGridWithReactQuery
        url={advisorleadDataUrl}
        requestParameter={{ advisor_id: advisorData?.advisor_id, start_date: dates.startDate, end_date: dates.endDate }}
        limit={10}
        search=""
        columns={columns}
        isServerPagination={true}
        dataMapper={(list) => list}
        height={'50rem'}
      />
      {accessModalToggle && (
        <AccessModal
          open={accessModalToggle}
          setOpen={setAccessModalToggle}
          componytabdata={companyAccessData}
          catagorydata={catagoryAccessData}
          dep={dep}
          setDep={setDep}
          id={advisorData?.advisor_id}
        />
      )}
      {advisorProfileToggle && (
        <AdvisorProfile
          open={advisorProfileToggle}
          setOpen={setAdvisorProfileToggle}
          data={advisorProfileData}
          status={status}
          setStatus={setStatus}
        />
      )}
    </div>
  );
};

export default AdvisorInfoPage;